import { render } from "./patientUpdate.vue?vue&type=template&id=74b3b911"
import script from "./patientUpdate.js?vue&type=script&lang=js"
export * from "./patientUpdate.js?vue&type=script&lang=js"

import "./patientUpdate.vue?vue&type=style&index=0&id=74b3b911&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__